import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getCities} from '../../services';
import {ICityFilter, ICityRes, ICityState} from "../types/ICity";
import {AppState} from "./rootReducer";

const initialState: ICityState = {
    status: "idle"
}

export const mostrarCities = createAsyncThunk(
    'mostrarCities', async (params:ICityFilter|undefined, thunkAPI ) => {
        const {cities} = thunkAPI.getState() as AppState;
        let paramsFilter = params || cities.filtered;

        const response = await getCities(paramsFilter)
        return {data: response.data as ICityRes, params: response.config.params}
    }
)
export const mostrarCitiesSinoEsta = createAsyncThunk(
    'mostrarCitiesSinoEsta', async (_,thunkAPI) => {
        let cities = (thunkAPI.getState() as AppState)?.cities;
        if (!!cities?.list?.items.length || cities.status === "loading") return false;

        return thunkAPI.dispatch(mostrarCities());

    }
)


const slice = createSlice({
    name: 'mostrarCities',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarCities
        builder.addCase(mostrarCities.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarCities.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarCities.rejected, (state ) => {
            state.status = "idle";
        })

    }
});

export default slice.reducer;
